import { useParams } from "react-router-dom";
import DetailedRFQ from "../../components/BuyerDashboard/Requirements/DetailedRFQ";

export default function ReviewSellers() {
  const { id } = useParams();

  return (
    <DetailedRFQ id={id} userRole={"admin"} />
  );
}
